import qs from 'qs'
import lodash from 'lodash'
import cUtils from '@ccprivate/utils/dist/ccUtil.cjs'
/**
 * 获取图表属性设置的function
 * @param type
 * @param config
 */
export function getChartAttr (type, config) {
  switch (type) {
    case 'line':
    case 'radar':
      return {
        label: 'lineStyle',
        val: {
          lineWidth: 2,
          cursor: 'pointer',
          lineDash: [8, 8]
        }
      }
    case 'column':
      return {
        label: 'columnStyle',
        val: {
          lineWidth: 1,
          stroke: '#ffd71a',
          strokeOpacity: 0.7,
          cursor: 'pointer',
          lineDash: [2, 2]
        }
      }
    case 'area':
      let { tField, seriesField } = config
      config['line']['style'] = (args) => {
        if (args) {
          if (args[seriesField] === tField) {
            return {
              lineDash: [8, 8],
              lineWidth: 2,
              cursor: 'pointer'
            }
          }
        }
      }
      config['line']['style']()
      return {
        label: 'areaStyle',
        val: {
          fill: 'transparent',
          lineWidth: 2
        }
      }
    case 'bar':
      return {
        label: 'barStyle',
        val: {
          lineWidth: 1,
          stroke: '#ffd71a',
          strokeOpacity: 0.7,
          cursor: 'pointer',
          lineDash: [2, 2]
        }
      }
    case 'pie':
      return {
        label: 'pieStyle',
        val: {
          lineWidth: 2,
          stroke: '#ffd71a',
          strokeOpacity: 0.7,
          cursor: 'pointer',
          lineDash: [2, 2]
        }
      }
  }
}

// 虚线配置
// function updateChartDot (config, name, value, index) {
//   let { seriesField, chartType, dotCol } = config
//   value ? config.tField.push(name) : config.tField.splice(index, 1, '')
//   let { label, val } = getChartAttr(chartType, config, name)
//   dotCol.splice(index, 1, value)
//   config[label] = (args) => {
//     if (args) {
//       if (config['tField'].includes(args[seriesField])) {
//         return val
//       }
//     }
//   }
//   if (value) {
//     config[label]()
//   } else {
//     if (!dotCol.includes(true)) {
//       config.label = null
//     } else {
//       config[label]()
//     }
//   }
//   if (!value && chartType === 'area') {
//     config['line']['style'] = {}
//   }
//   return config
// }

/**
 * 自定义label属性
 * @param config
 * @param key
 * @param value
 * @param alias
 */
export function setLabelAttr (config, parentKey, key, value, alias) {
  // 饼图
  let type = config.chartType
  if (type === 'pie') {
    if (key === 'type' && value === 'inner') {
      let temp = {
        label: {
          content: ({ percent }) => `${(percent * 100).toFixed(0)}%`
        }
      }
      config = lodash.merge(
        config,
        temp,
        qs.parse(`${alias}=${value}`)
      )
    } else {
      config = lodash.merge(
        config,
        qs.parse(`label[content]={name}{value}({percentage})`),
        qs.parse(`${alias}=${value}`)
      )
    }
  } else if (type === 'funnel') {
    if (key === 'content') {
      let temp = {
        label: {
          content: (v) => `${v[config['xField']]}\n${cUtils.format.fillNumber(v[config['yField']], 3, ',')} ${value}`
        }
      }
      config = lodash.merge(
        config,
        temp
      )
    }
  }
  return config
}

/**
 * 处理图表回调函数 因为不能JSON化 需要手动再次注入
 * @param item
 */
export function setAttrFnCb (item) {
  for (let prop in item.config) {
    if (prop === 'isPercent' && item.config['label']) {
      if (item.config.__isDataField && item.config[prop]) {
        let dataField = item.config.__isDataField
        item.config.label.content = (v) => (v[item.config[dataField]] * 100).toFixed(0) + '%'
      } else if (typeof item['config']['label'] !== 'object') {
        item.config.label = false
      }
    }
    // 如果是桑基图
    if (item.config.chartType === 'sanKey') {
      item.config.label = {
        formatter: ({ name }) => name,
        callback: (x) => {
          const isLast = x[1] === 1
          return {
            style: {
              fill: '#ffffff',
              textAlign: isLast ? 'end' : 'start'
            },
            offsetX: isLast ? -8 : 8
          }
        },
        layout: [{ type: 'hide-overlap' }]
      }
    }
  }
  return item
}

/**
 * 处理双轴图数据映射 g改变的是数据结构 而非config文件
 * @param item
 */
export function setSpareData (item) {
  let { isDual, mapCol } = item.config
  let data = item?.data?.['tBody'] ? item.data['tBody'] : item.data
  let spareData = lodash.cloneDeep(data)
  // 设置了isDual为true才处理数据
  if (isDual) {
    // 拿到设置的映射值
    let x, y, z
    mapCol.forEach(item => {
      if (item.key === 'xField') {
        x = item.value
      } else if (item.key === 'yField') {
        y = item.value
      } else {
        z = item.value
      }
    })
    spareData = (spareData || []).map(item => {
      item['x'] = item[x]
      item['y'] = item[y]
      item['z'] = item[z]
      return item
    })
  }
  return spareData
}
